import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';

import { GetInvoiceDetails } from '../../api/IncomingInvoice.api';

import { InitialStage } from './components/InitialStage';
import InvoiceBlock from './components/InvoiceBlock';

type Props = {
  selectedInvoice: number | null;
  setSelectedInvoice: React.Dispatch<React.SetStateAction<number | null>>;
  onBackToSearch?: () => void;
};

function IncomeInvoice({
  selectedInvoice,
  setSelectedInvoice,
  onBackToSearch,
}: Props) {
  const { data: invoice, isLoading } = useQuery({
    queryKey: ['invoice', selectedInvoice],
    queryFn: () => GetInvoiceDetails(selectedInvoice),
    enabled: !!selectedInvoice,
    retryDelay(failureCount) {
      if (failureCount > 0) {
        toast.error('مشكلة في جلب بيانات الفاتورة');
        setSelectedInvoice(null);
      }
      return 200;
    },
  });

  return (
    <div className="space-y-4">
      {/* Back Button */}
      {onBackToSearch && (
        <div className="mb-4">
          <Button
            variant="outline"
            onClick={onBackToSearch}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            العودة إلى البحث
          </Button>
        </div>
      )}

      {/* Invoice Content */}
      <div className="w-full">
        {(!selectedInvoice || isLoading) && (
          <InitialStage isLoading={isLoading} />
        )}
        {invoice?.data && !isLoading && (
          <InvoiceBlock invoice={invoice?.data} />
        )}
      </div>
    </div>
  );
}

export default IncomeInvoice;
